document.querySelectorAll("li.header__menu-item.header__menu-item--parent.list-menu__item").forEach((element) => {
  element.querySelectorAll(".js-hover-link").forEach((el) => {
    const hoverTitle = el.getAttribute("data-hover-title");
    const hoverDesc = el.getAttribute("data-hover-description");
    const hoverImage = el.getAttribute("data-hover-image");

    const targetTitle = element.querySelector(".js-hover-title[data-id='hover-title-collection-preview']");
    const mainTitle = element.querySelector(".js-main-title[data-id='main-title-collection-preview']");
    const targetDesc = element.querySelector(".js-hover-desc[data-id='hover-desc-collection-preview']");
    const mainDesc = element.querySelector(".js-main-desc[data-id='main-desc-collection-preview']");
    const mainCTA = element.querySelector(".js-main-cta[data-id='main-cta-collection-preview']");
    const mainImage = element.querySelector(".js-main-image[data-id='main-image-collection-preview']");
    const cardMedia = element.querySelector(".collection-feature .card-media");
    const mainImageSrc = mainImage?.src;

    if (hoverTitle) {
      el.addEventListener("mouseover", () => {
        targetTitle.innerText = hoverTitle;
        targetTitle.classList.remove("hidden");
        mainTitle.classList.add("hidden");

        targetDesc.innerText = hoverDesc;
        targetDesc.classList.remove("hidden");
        mainDesc.classList.add("hidden");

        mainCTA.classList.add("hidden");

        if (hoverImage) {
          mainImage.src = hoverImage;
        } else {
          cardMedia.style.display = "none"
        }
      });

      el.addEventListener("mouseout", () => {
        targetTitle.innerText = "";
        targetTitle.classList.add("hidden");
        mainTitle.classList.remove("hidden");

        targetDesc.innerText = "";
        targetDesc.classList.add("hidden");
        mainDesc.classList.remove("hidden");

        mainCTA.classList.remove("hidden");

        mainImage.src = mainImageSrc;
        cardMedia.style.display = "block"
      });
    }
  });
});

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

document.querySelectorAll('[data-cookie-trigger]').forEach((el) => {
  el.addEventListener('click', () => {
    const cookieName = 'genderURL';
    const cookieValue = el.dataset.cookieTrigger;

    if (cookieName && cookieValue) {
      setCookie(cookieName, cookieValue, 30);
    }
  })
})
